module.exports = __webpack_public_path__ + "static/ApercuMonoProLight-9c0098074144af1f2e31325e287d2fd3.ttf";